import { isEmbroideryPersonalizationProduct } from '../../embroidery-details';
import { GIFT_BOX_PRODUCT_TYPE, GIFT_CARD_PRODUCT_TYPE } from '../../../config';
export const isGiftBox = (item)=>item.product_type === GIFT_BOX_PRODUCT_TYPE;
export const isGiftCard = (item)=>item.product_type === GIFT_CARD_PRODUCT_TYPE;
export const isAlreadyAssociated = (item)=>!!(item.properties || {})._gift_box_parent_id;
export const isGiftSet = (item)=>!!(item.properties || {})._gift_set_id;
export const isSelectableItem = (item)=>!isGiftBox(item) && !isGiftCard(item) && !isGiftSet(item) && !isAlreadyAssociated(item) && !isEmbroideryPersonalizationProduct(item);
